import {useEffect, useRef, useState} from "react";
import ErrorIcon from "@mui/icons-material/Error";
import Typography from "@mui/material/Typography";
import {useAuth} from "../../store/auth-context";
import {
    Box, Button, Card, CardContent, CardMedia, CircularProgress,
    IconButton,
    InputAdornment,
    Stack,
    TextField
} from "@mui/material";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import AppOnly from "../platforms/AppOnly";
import WebOnly from "../platforms/WebOnly";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';


const RegisterWeb = (props) => {
    return <>
        <Stack direction='row'>
            <Box p={5} minWidth={400} sx={{borderRight: '1px solid #00000021'}}>
                <Stack direction='column' spacing={2} alignItems='center' justifyContent='center'>
                    <img width="100" height="100" src="/logo.svg" alt="Logo Sbobbi"/>
                    {/*<Typography variant="h3" mt={-2} mb={5} component="div" sx={{color: "#376dab"}}>SBOBBI</Typography>*/}
                </Stack>
                <Typography variant="h6" mt={5}>Registrati ora per iniziare a trascrivere i tuoi file audio in
                    testo!</Typography>
                <Typography variant='h6' mb={3}> Crea il tuo account in pochi secondi e accedi subito a tutte le
                    funzionalità per semplificare il tuo lavoro.</Typography>
                <Typography variant='body1'>Hai già un account? <a href='#' onClick={props.onModeChange}>Accedi!</a>
                </Typography>
            </Box>
            <Box p={5} minWidth={350}>
                <RegisterForm {...props} />
            </Box>
        </Stack>
    </>
};

const RegisterMobile = (props) => {
    return <>
        <Card sx={{py:5, pb:3, boxSizing: 'border-box', px: 1, height: '100dvh', overflow: 'auto'}}>
            <CardMedia
                sx={{borderRadius: 1, mx: 'auto', p: '4', width: 'auto'}}
                component="img"
                alt="Logo Sbobbi"
                height="100"
                image="/logo.svg"
            />
            <CardContent sx={{ px: {xs: 0, sm: 2}, py: 2, mt: 1, textAlign: 'center' }}>
                <RegisterForm {...props} />
                <Typography mt={2} variant='body1'>
                    Hai già un account? <a href='#' onClick={props.onModeChange}>Accedi!</a>
                </Typography>
            </CardContent>
        </Card>
    </>;
}

const RegisterForm = (props) => {
    const authCtx = useAuth();

    const elementRefs = {
        email: useRef(''),
        password: useRef(''),
        confirmPassword: useRef(''),
        name: useRef(''),
        lastname: useRef('')
    };

    const [errors, setErrors] = useState([]);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    useEffect(() => {
        if (!authCtx.response)
            return;
        if(authCtx.response.state === 'success') {
            setSuccess(true);
            props.onModeChange('verification_sent');
        } else {
            if (authCtx.response.error && authCtx.response.error.code === 409) {
                setErrors([...errors, "emailNotAvailable", "email"]);
                setLoading(false);
            }
        }
    }, [authCtx.response]);

    const checkElementValidity = element => {
        let pattern = null;
        let error = false;
        switch (element) {
            case 'email':
                pattern = /^\S+@\S+\.\S+$/;
                error = !(pattern.test(elementRefs.email.current.value.trim()));
                break;
            case 'password':
                pattern = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,}$/;
                error = !(pattern.test(elementRefs.password.current.value.trim()));
                break;
            case 'confirmPassword':
                error = !(elementRefs.confirmPassword.current.value.trim() !== "" && elementRefs.password.current.value.trim() === elementRefs.confirmPassword.current.value.trim() && !errors.includes('password'));
                break;
            case 'name':
                error = !(elementRefs.name.current.value.trim() !== "");
                break;
            case 'lastname':
                error = !(elementRefs.lastname.current.value.trim() !== "");
                break;
        }

        if (error) {
            if (errors.includes(element))
                return false;
            setErrors(prevState => [...prevState, element]);
            return false;
        } else {
            if (errors.includes(element))
                setErrors(prevState => prevState.filter(err => err !== element));
            return true;
        }
    };

    const checkFormValidity = () => {
        setErrors([]);
        let isValid = true;
        Object.keys(elementRefs).forEach((key) => {
            if (!checkElementValidity(key))
                isValid = false;
        })
        return isValid;
    }

    const onSubmitHandler = (ev) => {
        ev.preventDefault();
        if (checkFormValidity()) {
            const email = elementRefs.email.current.value.trim();
            const password = elementRefs.password.current.value.trim();
            const name = elementRefs.name.current.value.trim();
            const lastname = elementRefs.lastname.current.value.trim();

            authCtx.register(email, password, name, lastname);
            setLoading(true)
        }
    }

    return <>
        <form action="" onSubmit={onSubmitHandler}>
            <Box overflow={'auto'}>
                <TextField
                    id="email-input"
                    error={errors.includes('email')}
                    helperText={errors.includes('email') ? "Email non valida!" : ""}
                    label="Email"
                    variant="outlined"
                    autoComplete="email"
                    inputRef={elementRefs.email}
                    onBlur={checkElementValidity.bind(this, "email")}
                    fullWidth={true}
                    sx={{mb: 2}}
                />
                <TextField
                    id="password-input"
                    error={errors.includes('password')}
                    helperText={errors.includes('password') ? "La password deve contenere almeno una lettera maiuscola, una minuscola, un numero, un simbolo e deve essere lunga almeno 8 caratteri!" : ""}
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    variant="outlined"
                    autoComplete="current-password"
                    inputRef={elementRefs.password}
                    onBlur={checkElementValidity.bind(this, "password")}
                    fullWidth={true}
                    sx={{mb: 2}}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
                <TextField
                    id="confirm-password-input"
                    error={errors.includes('confirmPassword')}
                    helperText={errors.includes('confirmPassword') ? "Le password non coincidono!" : ""}
                    label="Conferma password"
                    type={showConfirmPassword ? "text" : "password"}
                    variant="outlined"
                    autoComplete="current-password"
                    inputRef={elementRefs.confirmPassword}
                    onBlur={checkElementValidity.bind(this, "confirmPassword")}
                    fullWidth={true}
                    sx={{mb: 2}}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle confirm password visibility"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    edge="end"
                                >
                                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
                <TextField
                    id="name-input"
                    error={errors.includes('name')}
                    helperText={errors.includes('name') ? "Inserire il nome!" : ""}
                    label="Nome"
                    variant="outlined"
                    autoComplete="name"
                    inputRef={elementRefs.name}
                    onBlur={checkElementValidity.bind(this, "name")}
                    fullWidth={true}
                    sx={{mb: 2}}
                />
                <TextField
                    id="lastname-input"
                    error={errors.includes('lastname')}
                    helperText={errors.includes('lastname') ? "Inserire il cognome!" : ""}
                    label="Cognome"
                    variant="outlined"
                    autoComplete="lastname"
                    inputRef={elementRefs.lastname}
                    onBlur={checkElementValidity.bind(this, "lastname")}
                    fullWidth={true}
                    sx={{mb: 2}}
                />
            </Box>
            <Stack direction="row" alignItems="center" mb={{xs: 0, sm: 5}} spacing={3}>
                {errors.includes('emailNotAvailable') && <>
                    <ErrorIcon color='error' fontSize="large"/>
                    <Typography
                        variant="body1"
                        component="div"
                        color="error">
                        Questo indirizzo email è associato ad un account esistente
                    </Typography>
                </>}
                {success && <>
                    <ThumbUpIcon color='success' fontSize="large"/>
                    <Typography
                        variant="body1"
                        component="div"
                        color="success">
                        Registrazione avvenuta con successo! Ti abbiamo inviato una mail con il link per verificare il tuo account
                    </Typography>
                </>}
            </Stack>
            <Box textAlign="center">
                {!loading && <Button sx={{height: 50, fontSize: 18}} size='large' type='submit' variant='contained'
                                     fullWidth={true}>
                    Registrati
                </Button>}
                {loading && <CircularProgress />}
            </Box>
        </form>
    </>
}

const Register = (props) => {
    return <>
        <AppOnly>
            <RegisterMobile {...props} />
        </AppOnly>
        <WebOnly>
            <RegisterWeb {...props} />
        </WebOnly>
    </>
};

export default Register;